import { useNavigate } from "react-router-dom";

export const useHome = () => {
  const navigate = useNavigate();

  const goToContultOs = () => {
    navigate("/search-os");
  };

  const goToPreOs = () => {
    navigate("/create-pre-os");
  };
  const goToPosts = () => {
    navigate("/posts");
  };

  const goToPostByCep = () => {
    navigate("/post-by-cep");
  };

  return {
    goToContultOs,
    goToPreOs,
    goToPosts,
    goToPostByCep,
  };
};
